import React from 'react'
import css from './UserCardOverlayItem.module.css'

const UserCardRow = ({ children, icon, ...props }) => {
  return (
    <div className={css.wrapper}>
      <div className={css.icon}>
        {icon}
      </div>
      <span className={css.value}>{children}</span>
    </div>
  )
}

export default UserCardRow



// WEBPACK FOOTER //
// ./components/Customers/presentational/UserCardOverlayItem.js